export default function stripHtmlToText(html) {
  var tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  var res = tmp.textContent || tmp.innerText || '';
  res.replace('<br>', '');
  res = res.trim();
  return res;
}
